'use client';

import { useEffect, useRef } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useAuth } from './AuthProvider';

const REFERRAL_CODE_KEY = 'slidetoanki_referral_code';
const CODE_PATTERN = /^[a-z0-9]{8,16}$/;

export function ReferralCapture() {
  const { user } = useAuth();
  const posthog = usePostHog();
  const claimAttempted = useRef(false);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('ref')?.trim().toLowerCase();
    if (!code || !CODE_PATTERN.test(code)) return;
    localStorage.setItem(REFERRAL_CODE_KEY, code);
    posthog?.capture('referral_arrived', {
      referral_code: code,
      landing_path: window.location.pathname,
    });
  }, [posthog]);

  useEffect(() => {
    if (!user || claimAttempted.current) return;
    const code = localStorage.getItem(REFERRAL_CODE_KEY)?.trim().toLowerCase() || '';
    if (!CODE_PATTERN.test(code)) return;
    claimAttempted.current = true;
    posthog?.capture('referral_claim_started', { referral_code: code });

    fetch('/api/referrals/claim', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .then(async response => {
        const result = await response.json().catch(() => ({})) as {
          claimed?: boolean;
          reason?: string;
        };
        posthog?.capture(result.claimed ? 'referral_claim_succeeded' : 'referral_claim_failed', {
          referral_code: code,
          reason: result.reason || `http_${response.status}`,
        });
        if (result.claimed || ['self_referral', 'invalid_code', 'different_referral_claimed'].includes(result.reason || '')) {
          localStorage.removeItem(REFERRAL_CODE_KEY);
        }
      })
      .catch(error => {
        claimAttempted.current = false;
        posthog?.capture('referral_claim_failed', {
          referral_code: code,
          reason: error instanceof Error ? error.message : 'network_error',
        });
      });
  }, [posthog, user]);

  return null;
}
